export default {
    getQtdProdutosNoCarrinho: state =>{
        let qtdTotal = 0;
        
        state.produtos.forEach(prod => {
            qtdTotal += prod.quantidadeTotal
        });
        return qtdTotal;
    }
}